import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Injectable,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { AddEditFormGeneric } from './AddEditFormGeneric';
import { ModalGeneric } from './ModalGeneric';

@Injectable({
  providedIn: 'root'
})
@Component({
    template: '',
    standalone: false
})
export abstract class AddEditModalGeneric<T, F extends AddEditFormGeneric<T>> extends ModalGeneric implements OnInit, OnDestroy {

  @ViewChild('form') form: F;

  @Input() triggerTitle = 'Neu erstellen';

  @Output() refresh  = new EventEmitter<void>();

  public isConfirmLoading = false;
  public title = 'Neu erstellen';
  public object: null | T = null;
  protected isNew = false;
  private readonly _confirm = inject(NzModalService);
  private readonly _zone = inject(NgZone);
  private _discardConfirmOpen = false;

  protected constructor(
    protected cdr: ChangeDetectorRef
  ) {
    super(cdr);
  }

  ngOnInit(): void {
  }

  showModal(object: null | T): void {
    this.isNew = (object === null);
    this.object = object;
    this.rebuildTitle();
    super.showModal();
    this.cdr.detectChanges();
    this.resetFormAfterOpen();
  }

  rebuildTitle(): void {
    this.title = this.isNew ? 'Neu erstellen' : 'Bearbeiten';
  }

  handleCancel(): void {
    if (this._discardConfirmOpen) {
      return;
    }
    if (typeof this.form?.resetSubmitState === 'function' && this.form.form?.dirty) {
      this._discardConfirmOpen = true;
      this._confirm.confirm({
        nzTitle: 'Eingaben verwerfen?',
        nzContent: 'Ihre Änderungen gehen verloren.',
        nzOkText: 'Verwerfen',
        nzCancelText: 'Weiter bearbeiten',
        nzOkDanger: true,
        nzNoAnimation: true,
        nzOnOk: () => {
          this._zone.run(() => this.dismissModal());
        },
        nzOnCancel: () => {
          this._discardConfirmOpen = false;
        }
      });
      return;
    }
    this.dismissModal();
  }

  handleOk(): void {
    this.isConfirmLoading = true;
    this.form.submitForm();
  }

  onFormFinished(state: boolean): void {
    if (state) {
      this.dismissModal();
      this.refresh.emit();
    }

    this.isConfirmLoading = false;
  }

  protected dismissModal(): void {
    this._discardConfirmOpen = false;
    super.handleCancel();
  }

  private resetFormAfterOpen(): void {
    const run = () => {
      if (typeof this.form?.resetSubmitState !== 'function') {
        return;
      }
      this.form.resetSubmitState(this.isNew);
      setTimeout(() => this.form.form?.markAsPristine());
    };
    if (this.form) {
      run();
      return;
    }
    setTimeout(run);
  }
}
